import { map, toNumber } from 'lodash';

import {
  FullBOUserResponseModel,
  SelfEmployedRequestModel,
} from 'api/backofficeApiClient';

export interface SelfEmployedProfileFormValues {
  ownerInfo: {
    firstName: string;
    lastName: string;
    email: string;
  };
  businessName: string;
  businessPhone: string;
  country?: number;
  state?: number;
  internationalStateName?: string;
  city: string;
  internationalCityName?: string;
  address: string | null;
  zip: string;
  industry: string[];
  assignmentLocations?: number[] | null;
  assignment?: boolean;
  termsAndConditions?: boolean;
  isRegisteredOnMarketPlace?: boolean;
  website?: string;
  mbpClientSuccessPartnerUserId?: string;
  mspSalesRepresentativeUserId?: string;
  mbpBillingRepresentativeUserId?: string;
  recipientEmail1?: string;
  recipientEmail2?: string;
  recipientEmail3?: string;
}

export const mapSelftEployedProfileToRequest = (
  values: SelfEmployedProfileFormValues,
  profileInfo?: FullBOUserResponseModel,
): SelfEmployedRequestModel => {
  const {
    ownerInfo,
    businessName,
    businessPhone,
    state,
    city,
    address,
    zip,
    website,
    industry,
    assignmentLocations,
    assignment,
    country,
    internationalStateName,
    internationalCityName,
    mbpClientSuccessPartnerUserId,
    mspSalesRepresentativeUserId,
    mbpBillingRepresentativeUserId,
    recipientEmail1,
    recipientEmail2,
    recipientEmail3,
  } = values;

  return {
    website: website || undefined,
    ownerInfo: {
      firstName: ownerInfo.firstName.trim(),
      lastName: ownerInfo.lastName.trim(),
      email: ownerInfo.email.trim(),
    },
    businessInfo: {
      name: businessName.trim(),
      phoneNumber: businessPhone.replace(/\D+/g, ''),
      location: {
        countryId: toNumber(country),
        stateId: state || undefined,
        city: city.trim(),
        address: address?.trim(),
        zipCode: zip?.trim() || undefined,
        internationalStateName: internationalStateName || undefined,
        internationalCityName: internationalCityName?.trim() || undefined,
      },
      industry,

      // for edit we need pass those two fields too, because it is required
      assignmentLocations:
        (!!profileInfo
          ? (map(
              profileInfo?.businessInfo?.assignmentLocations,
              'id',
            ) as number[])
          : assignmentLocations) || undefined,
      assignment: !!profileInfo
        ? profileInfo?.businessInfo?.assignment
        : assignment,
    },
    companyId: profileInfo?.companyId || undefined,
    myBasePayTeam:
      mbpClientSuccessPartnerUserId ||
      mspSalesRepresentativeUserId ||
      mbpBillingRepresentativeUserId
        ? {
            mbpClientSuccessPartnerUserId:
              mbpClientSuccessPartnerUserId || undefined,
            mspSalesRepresentativeUserId:
              mspSalesRepresentativeUserId || undefined,
            mbpBillingRepresentativeUserId:
              mbpBillingRepresentativeUserId || undefined,
          }
        : undefined,
    activityReportRecipients:
      recipientEmail1 || recipientEmail2 || recipientEmail3
        ? {
            recipientEmail1: recipientEmail1?.trim() || undefined,
            recipientEmail2: recipientEmail2?.trim() || undefined,
            recipientEmail3: recipientEmail3?.trim() || undefined,
          }
        : undefined,
  };
};
